/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Permissions, PermissionsInterface } from "../Permissions";

const _abi = [
  {
    inputs: [],
    name: "ArraysDifferentLength",
    type: "error",
  },
  {
    inputs: [],
    name: "CalldataOutOfBounds",
    type: "error",
  },
  {
    inputs: [],
    name: "DelegateCallNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "FunctionNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "FunctionSignatureTooShort",
    type: "error",
  },
  {
    inputs: [],
    name: "NoMembership",
    type: "error",
  },
  {
    inputs: [],
    name: "NotEnoughCompValuesForOneOf",
    type: "error",
  },
  {
    inputs: [],
    name: "ParameterGreaterThanAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "ParameterLessThanAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "ParameterNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "ParameterNotOneOfAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "ScopeMaxParametersExceeded",
    type: "error",
  },
  {
    inputs: [],
    name: "SendNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "TargetAddressNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "UnacceptableMultiSendOffset",
    type: "error",
  },
  {
    inputs: [],
    name: "UnsuitableDynamic32CompValueSize",
    type: "error",
  },
  {
    inputs: [],
    name: "UnsuitableOneOfComparison",
    type: "error",
  },
  {
    inputs: [],
    name: "UnsuitableRelativeComparison",
    type: "error",
  },
  {
    inputs: [],
    name: "UnsuitableStaticCompValueSize",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
    ],
    name: "AllowTarget",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
    ],
    name: "RevokeTarget",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "resultingScopeConfig",
        type: "uint256",
      },
    ],
    name: "ScopeAllowFunction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "bool[]",
        name: "isParamScoped",
        type: "bool[]",
      },
      {
        indexed: false,
        internalType: "enum ParameterType[]",
        name: "paramType",
        type: "uint8[]",
      },
      {
        indexed: false,
        internalType: "enum Comparison[]",
        name: "paramComp",
        type: "uint8[]",
      },
      {
        indexed: false,
        internalType: "bytes[]",
        name: "compValue",
        type: "bytes[]",
      },
      {
        indexed: false,
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "resultingScopeConfig",
        type: "uint256",
      },
    ],
    name: "ScopeFunction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "resultingScopeConfig",
        type: "uint256",
      },
    ],
    name: "ScopeFunctionExecutionOptions",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum ParameterType",
        name: "paramType",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "enum Comparison",
        name: "paramComp",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "compValue",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "resultingScopeConfig",
        type: "uint256",
      },
    ],
    name: "ScopeParameter",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum ParameterType",
        name: "paramType",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "bytes[]",
        name: "compValues",
        type: "bytes[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "resultingScopeConfig",
        type: "uint256",
      },
    ],
    name: "ScopeParameterAsOneOf",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "resultingScopeConfig",
        type: "uint256",
      },
    ],
    name: "ScopeRevokeFunction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
    ],
    name: "ScopeTarget",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "resultingScopeConfig",
        type: "uint256",
      },
    ],
    name: "UnscopeParameter",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "keyForCompValues",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "epoch",
        type: "uint32",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
    ],
    name: "keyForFunctions",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

const _bytecode =
  "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";

type PermissionsConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: PermissionsConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Permissions__factory extends ContractFactory {
  constructor(...args: PermissionsConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "Permissions";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Permissions> {
    return super.deploy(overrides || {}) as Promise<Permissions>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Permissions {
    return super.attach(address) as Permissions;
  }
  connect(signer: Signer): Permissions__factory {
    return super.connect(signer) as Permissions__factory;
  }
  static readonly contractName: "Permissions";
  public readonly contractName: "Permissions";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PermissionsInterface {
    return new utils.Interface(_abi) as PermissionsInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Permissions {
    return new Contract(address, _abi, signerOrProvider) as Permissions;
  }
}
